export default __webpack_public_path__ + "static/media/ttdBTS.6ba56dc5.png";